// src/components/MainLayout.jsx
import RightSidebar from "./RightSidebar";
import { Outlet, useLocation } from "react-router-dom";
import React, { useMemo } from "react";
import Footer from "./Footer";
import { useTopOffset } from "./useTopOffset";
import "./MainLayout.css";

const MainLayout = () => {
  const location = useLocation();

  const pathname = location.pathname || "";

  const isMarketplace =
    pathname.startsWith("/market") ||
    pathname.startsWith("/marketplace");

  const isAuthPage =
    pathname === "/login" ||
    pathname === "/register";

  const hasCatbar = useMemo(() => {
    if (isAuthPage) return false;
    return true;
  }, [isAuthPage]);

  // Hide right sidebar on profile pages so account pages have full width
  const showRightSidebar = !isAuthPage && !pathname.startsWith("/profile") && !pathname.startsWith("/user/");
  const showFooter = !isAuthPage;

  useTopOffset(["siteHeader", "categoryBar"]);

  return (
    <div className={`layout-wrapper${isAuthPage ? " auth-layout" : ""}`}>
      <div className={`layout-inner${isAuthPage ? " auth-layout-inner" : ""}`}>
        <div
          className={`categories-container no-left app-main${
            hasCatbar ? " has-catbar" : ""
          }${isAuthPage ? " auth-page-shell" : ""}`}
        >
          <div
            className={`main-content${
              isMarketplace ? " marketplace-content" : ""
            }${isAuthPage ? " auth-main-content" : ""}`}
          >
            <Outlet />
          </div>

          {showRightSidebar && (
            <div className="sidebar-wrapper right">
              <RightSidebar />
            </div>
          )}
        </div>

        {showFooter && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;